import { connect } from 'react-redux'
import {
  StateProps,
  UnhandledExceptionHandlerComponent
} from './UnhandledExceptionHandler'
import UnhandledException from '../../model/UnhandledException'
import { raiseException, ClearException } from './actions/RaiseException'
import { withRouter } from 'react-router'
import { RootState } from '../../reducers/root-reducer'

// tslint:disable-next-line:no-any
const mapStateToProps = ({ exception }: RootState, ownProps: any): StateProps => {
  return {
    exceptionIssue: exception.exceptionIssue,
    error: exception.errorMessage,
    hasException: exception.hasUnhandledException,
    exception: exception.unhandledException
  }
}

const mapDispatchToProps = {
  raiseException: (exception:UnhandledException) => raiseException(exception),
  clearException: () => ClearException()
}

export const UnhandledExceptionHandlerContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UnhandledExceptionHandlerComponent)
)
